import { all, fork } from 'redux-saga/effects';
import { watchGetDocuments } from './documents/get';
import { watchUpdateDocResourceSections } from './resources/update';
import { watchCreateDocSectionTasks, watchCreateDocTasks } from './tasks/create';
import { watchGetDocTasks } from './tasks/get';
import { watchUpdateDocTaskIdNameMap } from './tasks/id-name-map';
import { watchUpdateDocTasks } from './tasks/update';
export const documentRootSaga = function*() {
    yield all([
        fork(watchGetDocuments),
        fork(watchGetDocTasks),
        fork(watchCreateDocTasks),
        fork(watchCreateDocSectionTasks),
        fork(watchUpdateDocTasks),
        fork(watchUpdateDocTaskIdNameMap),
        fork(watchUpdateDocResourceSections)
    ]);
};
